
import { ValueMetricsSection as GenericValueMetricsSection } from "@/components/services/specializations/ValueMetricsSection";

export const ValueMetricsSection = () => {
  return (
    <GenericValueMetricsSection
      title="Transform Your Security Culture"
      subtitle="Measurable Results"
      description="Our security awareness training delivers quantifiable improvements in your organization's security posture through behavioral change."
      metrics={[
        {
          value: "90%",
          label: "Phishing Reduction",
          description: "Average reduction in successful phishing attempts after implementing our complete training program."
        },
        {
          value: "60%",
          label: "Incident Decrease",
          description: "Typical reduction in security incidents caused by human error within the first year."
        },
        {
          value: "85%",
          label: "Reporting Increase",
          description: "Average increase in employee reporting of suspicious activities and potential security threats."
        },
        {
          value: "24/7",
          label: "Vigilant Protection",
          description: "Continuous protection as employees become your most effective security sensors throughout the organization."
        }
      ]}
    />
  );
};
